import React, { FC } from 'react';
import { User } from 'api/models';
import { FieldValue } from 'api/notifications/meta';
import { TranslationKey, useTranslation } from 'hooks/use-translation';
import { Strong, Value } from '../basics';
import { FieldChangedMessage, renderFieldValue } from './field-changed';

export const ProjectPhaseFieldChangedMessage: FC<{
  by: User;
  name: string;
  phase: string;
  from?: FieldValue;
  to?: FieldValue;
  normal?: boolean;
}> = ({ by, name, phase, from, to, normal }) => (
  <FieldChangedMessage
    by={by}
    name={useTranslation(`fields.${name}` as TranslationKey)}
    item={normal ? <Value>{phase}</Value> : <Strong>{phase}</Strong>}
    from={renderFieldValue(from)}
    to={renderFieldValue(to)}
  />
);
